export default "__VITE_ASSET__BGJicg9P__"